import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWistiaComponent } from './simple-icons-wistia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWistiaComponent ],
    exports:      [ SimpleIconsWistiaComponent ],
    bootstrap:    []
})
export class SimpleIconsWistiaModule {}
